export const GET_DEPARTMENTS = "GET_DEPARTMENTS"
export const GET_DEPARTMENTS_SUCCESS = "GET_DEPARTMENTS_SUCCESS"
export const GET_DEPARTMENTS_FAIL = "GET_DEPARTMENTS_FAIL"

export const ADD_DEPARTMENTS = "ADD_DEPARTMENTS"
export const ADD_DEPARTMENTS_SUCCESS = "ADD_DEPARTMENTS_SUCCESS"
export const ADD_DEPARTMENTS_FAIL = "ADD_DEPARTMENTS_FAIL"

export const UPDATE_DEPARTMENTS = "UPDATE_DEPARTMENTS"
export const UPDATE_DEPARTMENTS_SUCCESS = "UPDATE_DEPARTMENTS_SUCCESS"
export const UPDATE_DEPARTMENTS_FAIL = "UPDATE_DEPARTMENTS_FAIL"

export const DELETE_DEPARTMENTS = "DELETE_DEPARTMENTS"
export const DELETE_DEPARTMENTS_SUCCESS = "DELETE_DEPARTMENTS_SUCCESS"
export const DELETE_DEPARTMENTS_FAIL = "DELETE_DEPARTMENTS_FAIL"

export const SET_DEPARTMENT_FIELD_ERRORS = "SET_DEPARTMENT_FIELD_ERRORS"